/**
 * TODO: OBSOLETE use the new jquery widget model.
 * 
 * Calls a method on jquery widget. Widget name is filtered by first argument (contains).
 * 
 * Definition: $(myWidget).callWidgetMethod('widget filter', 'method name', 'optional params')
 * Example: var options = $('#controlX').callWidgetMethod('agControl', 'option');
 *  
 * @returns widget method call result
 */
$.fn.callWidgetMethod = function () {
    var args = (arguments.length === 1 ? [arguments[0]] : Array.apply(null, arguments));
    var filter = args.splice(0, 1);
    var result = null;

    if (!this.length)
        return null;

    this.each(function () {
        for (var i in $(this).data()) {
            if (i.match(new RegExp(filter[0]))) {

                var func = $(this)[i];

                if (!func)
                    return true;

                result = func.apply($(this), args);
                break;
            }
        }

        return result == null;
    });

    return result;
};